import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Marketingsidebar from '../../../components/Marketing_bar';
import "./guideline.css";
import { useState } from 'react';
const AgentGuidelines = () => {
    const [isOpen, setIsOpen] = useState(false);
  return (
    <Row>
      <div className="screenHeight marketing-height-manage p-3">
    
        <Col
          lg="3"
          xl="3"
          sm="12"
          xs="12"
          className="bg-white shadow-sm marketing-sidebar-height sidebar-border rounded"
          
        >
           <Marketingsidebar isOpen={isOpen} setIsOpen={setIsOpen} />
        </Col>

 
        <Col
          lg={8}
          md={8}
          sm={8}
          className="p-5 shadow rounded"
          style={{ backgroundColor: "#f8fbff" }}
        >
          <div className="agent-guidelines-content">

            {/* Main Title */}
            <h2 className="mb-4" style={{ color: '#0353a4', fontWeight: 'bold' }}>
              Agent Guidelines
            </h2>

            {/* First Paragraph */}
            <p className="mb-4">
              You’ve selected <strong>Electronics and Clothing</strong>. Please focus your marketing and outreach within these areas. Changing categories after signup is not allowed.
            </p>

            {/* Second Paragraph */}
            <p className="mb-5">
              Each agent specializes in specific business sectors to ensure focused and efficient marketing.
            </p>

            {/* Third Paragraph */}
            <p className="mb-5">
              Electronics attract more urban customers. Clothing serves both rural and urban audiences. Focus your promotions according to these audience trends for better conversions. You earn a commission for every user who subscribes to a package through your referral. The higher the package, the greater your commission.
            </p>

            {/* Convincing the Shop Owner - Section Title */}
            <h4 className="mb-4" style={{ color: '#0353a4', fontWeight: 'bold' }}>
              Convincing the Shop Owner
            </h4>

            {/* 1- Identify the Right Shops */}
            <div className="mb-4">
              <h5 className="mb-2" style={{ color: '#0353a4', fontWeight: 600 }}>
                1- Identify the Right Shops
              </h5>
              <p className="mb-2">
                Use your assigned categories and areas (e.g., Electronics in Urban, or Clothing in Urban + Rural) to find shops that fit your target audience.
              </p>
              <p className="mb-0">
                Avoid random outreach — focus on the types of businesses that your category supports. This keeps your network strong and results better.
              </p>
            </div>

            {/* 2- Start the Conversation Confidently */}
            <div className="mb-4">
              <h5 className="mb-2" style={{ color: '#0353a4', fontWeight: 600 }}>
                2- Start the Conversation Confidently
              </h5>
              <p className="mb-2">
                When you contact a shopkeeper, be professional and positive:
              </p>
              <ul className="ps-4 mb-0">
                <li>Introduce yourself as an official marketing partner of the platform.</li>
                <li>Briefly explain what the platform does (helps shops display their products, connect with other businesses, and gain more visibility).</li>
                <li>Tell them you’re here to help their shop reach more customers through your marketing system.</li>
              </ul>
            </div>

            {/* 3- Present the Value (Use These Talking Points) */}
            <div className="mb-4">
              <h5 className="mb-2" style={{ color: '#0353a4', fontWeight: 600 }}>
                3- Present the Value (Use These Talking Points)
              </h5>

              {/* Connect to Their Customers */}
              <div className="mb-3">
                <strong>Connect to Their Customers</strong><br />
                <span style={{ fontStyle: 'italic' }}>
                  “Your shop will be connected directly to real customers interested in your products.”
                </span>
              </div>

              {/* Automatic Audience Updates */}
              <div className="mb-3">
                <strong>Automatic Audience Updates</strong><br />
                <span style={{ fontStyle: 'italic' }}>
                  “Every time you post a new product or offer, your followers and nearby users will see it immediately.”
                </span>
              </div>

              {/* Increase Visibility */}
              <div className="mb-3">
                <strong>Increase Visibility</strong><br />
                <span style={{ fontStyle: 'italic' }}>
                  “Your shop will appear more often in searches and recommendations — people will notice you faster.”
                </span>
              </div>

              {/* Engagement & Conversions */}
              <div className="mb-3">
                <strong>Engagement & Conversions</strong><br />
                <span style={{ fontStyle: 'italic' }}>
                  “More visibility means more clicks, messages, and chances for new business.”
                </span>
              </div>

              {/* Targeted Reach */}
              <div className="mb-3">
                <strong>Targeted Reach</strong><br />
                <span style={{ fontStyle: 'italic' }}>
                  “Your promotions will focus exactly where your customers are — in your city, area, or nearby localities.”
                </span>
              </div>

              {/* Custom Packages for Every Level */}
              <div className="mb-3">
                <strong>Custom Packages for Every Level</strong><br />
                <span style={{ fontStyle: 'italic' }}>
                  “Even the basic plan helps increase local visibility, while higher packages expand your reach and give you advanced options like ad posting and marketing management.”
                </span>
              </div>
            </div>

            {/* 4- Guide Them Through the Packages */}
            <div className="mb-4">
              <h5 className="mb-2" style={{ color: '#0353a4', fontWeight: 600 }}>
                4- Guide Them Through the Packages
              </h5>
              <p className="mb-2">
                Explain the packages simply:
              </p>
              <ul className="ps-4 mb-2">
                <li>
                  <strong>Standard Plan</strong> — “Your shop will be promoted in a 3 km area, appear in local searches, and gain audience impressions.”
                </li>
                <li>
                  <strong>Premium Plan</strong> — “Your shop will be marketed across a larger radius, get ad posting support, and receive ongoing promotion from me as your assigned marketer.”
                </li>
              </ul>
              <p className="mb-0">
                <strong>Tip:</strong> Always relate the package to their shop size and audience needs — not price.
              </p>
            </div>

            {/* 5- Use Results to Build Trust */}
            <div className="mb-4">
              <h5 className="mb-2" style={{ color: '#0353a4', fontWeight: 600 }}>
                5- Use Results to Build Trust
              </h5>
              <p className="mb-2">
                Mention that they’ll be able to see live statistics such as:
              </p>
              <ul className="ps-4 mb-2">
                <li>Number of views and clicks.</li>
                <li>Shop impressions in searches.</li>
                <li>Progress bar showing how much promotion has been completed.</li>
                <li>Active updates about their marketing progress.</li>
              </ul>
              <p className="mb-0">
                This builds credibility and motivates them to subscribe.
              </p>
            </div>

            {/* 6- Use Platform Tools to Market Their Shop */}
            <div className="mb-5">
              <h5 className="mb-2" style={{ color: '#0353a4', fontWeight: 600 }}>
                6- Use Platform Tools to Market Their Shop
              </h5>
              <p className="mb-2">
                Tell them that you’ll use in-platform tools like:
              </p>
              <ul className="ps-4 mb-2">
                <li>Posting updates on their Timeline.</li>
                <li>Creating and posting Ads.</li>
                <li>Managing Connections with related shops or consumers.</li>
                <li>Optimizing their Shop Profile for more visibility.</li>
                <li>Using available sales and engagement tools to boost reach.</li>
              </ul>
              <p className="mb-0">
                <strong>Explain:</strong> “The higher the package, the more tools I can use to promote your shop.”
              </p>
            </div>

            {/* Marketing & Advertising Tools - Section Title */}
            <h4 className="mb-4" style={{ color: '#0353a4', fontWeight: 'bold' }}>
              Marketing & Advertising Tools
            </h4>

            <p className="mb-4">
              You can use following tool to convince you client and for his advertising according to his selected package
            </p>

            {/* Marketing Tools */}
            <div className="mb-4">
              <strong>Marketing Tools</strong>
              <p className="mb-0">
                Poster & Banner Design, Ad Creation & Posting, Shop Timeline Promotion, Shop Connections & Networking, Local and Platform-based Marketing
              </p>
            </div>

            {/* Sales & Engagement Tools */}
            <div className="mb-4">
              <strong>Sales & Engagement Tools</strong>
              <p className="mb-0">
                Product Display & Boost, Audience Update Notifications, Sales Conversion Tracking, Customer Engagement via Platform, Shop Profile Management & Optimization
              </p>
            </div>

        
            <div className="mb-5">
              <strong>Platform Tools</strong>
              <p className="mb-0">
                Manage Client Shops, Monitor Marketing Progress & Goals, Handle Shop Communication, Analyze Impressions and Clicks
              </p>
            </div>

          
            <h4 className="mb-3" style={{ color: '#0353a4', fontWeight: 'bold' }}>
              Collaboration & Deals
            </h4>

            <p className="mb-0">
              Agents and shop owners may collaborate directly for marketing or sales growth. The platform does not interfere in private business arrangements, commissions, or agreements outside the system.
            </p>

          </div>
        </Col>
      </div>



    </Row>
  );
};

export default AgentGuidelines;